export default {"src":"/_next/static/image/public/carriers/Canpar.8dd7f6c397f1f08ccc0cca1e0994f102.svg","height":253,"width":1075};